document.addEventListener('DOMContentLoaded', function () {
  // Listen for clicks on any popup button
  document.querySelectorAll('.popup-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      e.stopPropagation()

      // Find the associated popup and overlay within the same container
      var parentContainer = this.closest('.size-chart-pop')
      var popupOverlay = parentContainer.querySelector('.popup-overlay')
      var popupContent = parentContainer.querySelector('.popup')

      // Display the popup and overlay
      if (popupOverlay && popupContent) {
        popupOverlay.style.display = 'block'
        popupContent.style.display = 'block'
      }
    })
  })

  // Listen for clicks on any popup close button
  document.querySelectorAll('.popup-close').forEach(function (closeBtn) {
    closeBtn.addEventListener('click', function () {
      var parentContainer = this.closest('.size-chart-pop')
      var popupOverlay = parentContainer.querySelector('.popup-overlay')
      var popupContent = parentContainer.querySelector('.popup')

      // Hide the popup and overlay
      if (popupOverlay && popupContent) {
        popupOverlay.style.display = 'none'
        popupContent.style.display = 'none'
      }
    })
  })

  // Close the popup when clicking outside
  document.body.addEventListener('click', function (e) {
    if (!e.target.closest('.size-chart-pop')) {
      document.querySelectorAll('.popup-overlay').forEach(function (overlay) {
        var popupContent = overlay.closest('.size-chart-pop').querySelector('.popup')
        overlay.style.display = 'none'
        popupContent.style.display = 'none'
      })
    }
  })

  // Prevent closing the popup when clicking inside the popup content
  document.querySelectorAll('.popup-overlay').forEach(function (overlay) {
    overlay.addEventListener('click', function (e) {
      e.stopPropagation()
    })
  })
})
